import { FC } from "react";
import { Trans } from "react-i18next";
import moment from "moment";

import { PayrollSubmissionResponse } from "types/aiAssistant";
import { defaultDateFormat } from "constants/shared";
import { getFormattedSum } from "helpers";

import { Text } from "uikit";

import {
  PayrollSubmissionSummaryContainer,
  PayrollSubmissionSummaryContainerInner,
} from "./styles";
import { PayrollSubmissionSummaryCell } from "./styles";

interface IProps {
  data: PayrollSubmissionResponse | null;
}

export const PayrollSubmissionSummary: FC<IProps> = ({ data }) => {
  const translationPrefix = "ai_assistant_pages.admin.payroll_run.summary";
  const { payroll } = data || {};

  const renderSummaryCell = (title: string, value: string) => {
    return (
      <PayrollSubmissionSummaryCell>
        <Text $fs="t12" $fw="semiBold" $variant="secondary" component="span">
          <Trans i18nKey={`${translationPrefix}.${title}`} />
        </Text>
        <Text $fs="t14" $fw="semiBold">
          {value || "-"}
        </Text>
      </PayrollSubmissionSummaryCell>
    );
  };

  return (
    <PayrollSubmissionSummaryContainer>
      <Text $fs="t14" $fw="semiBold">
        <Trans i18nKey={`${translationPrefix}.title`} />
      </Text>

      <PayrollSubmissionSummaryContainerInner>
        {renderSummaryCell("pay_date", moment(payroll?.payDate).format(defaultDateFormat))}
        {renderSummaryCell("total_payroll", getFormattedSum(payroll?.totalAmount || ""))}
        {renderSummaryCell("debit_date", moment(payroll?.debitDate).format(defaultDateFormat))}
        {renderSummaryCell("debit_amount", getFormattedSum(payroll?.debitAmount || ""))}
        {renderSummaryCell(
          "pay_period",
          `${moment(payroll?.startDate).format(defaultDateFormat)} - ${moment(payroll?.endDate).format(defaultDateFormat)}`,
        )}
        {renderSummaryCell("number_of_employees", payroll?.totalWorkersAmount?.toString() || "-")}
      </PayrollSubmissionSummaryContainerInner>
    </PayrollSubmissionSummaryContainer>
  );
};
